import { Component, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Subject, take, takeUntil } from "rxjs";
import { GlobalSearchService } from "../global-search.service";
import { accountUserTypeMap, getUserType } from "../../utils/userType";
import { SearchActionsService } from "../search-actions.service";
import { SearchHistoryService } from "../search-history.service";
@Component({
    selector: "app-search-accounts-view",
    templateUrl: "./search-accounts-view.component.html",
    styleUrls: ["./search-accounts-view.component.scss"],
})
export class SearchAccountsViewComponent implements OnInit, OnDestroy {
    readonly ITEM_SIZE = 160;
    readonly HIGHER_ITEM_SIZE = 200;
    params = { searchText: "", accountTypes: [] };
    selectedUserTypes$ = new BehaviorSubject([]);

    isLoading$ = new BehaviorSubject(true);
    destroy$ = new Subject<void>();
    accounts$ = new BehaviorSubject([]);
    totalCount$ = new BehaviorSubject(0);
    accountUserTypeMap = accountUserTypeMap;
    constructor(
        private searchService: GlobalSearchService,
        private searchActionsService: SearchActionsService,
        private searchHistoryService: SearchHistoryService
    ) {}

    ngOnInit(): void {
        this.searchService.searchStored$
            .pipe(takeUntil(this.destroy$))
            .subscribe((keyword: string) => {
                this.params = { ...this.params, searchText: keyword };
                this.search();
            });
        this.selectedUserTypes$
            .pipe(takeUntil(this.destroy$))
            .subscribe((types: string[]) => {
                this.params = { ...this.params, accountTypes: types };
                this.search();
            });
    }

    search(): any {
        this.searchService.searchAccounts(this.params).subscribe(({ data }) => {
            this.accounts$.next(data.data || []);
            this.totalCount$.next(data.totalCount || 0);
            this.isLoading$.next(false);
        });
    }

    isUserTypeSelected(userType) {
        if (this.selectedUserTypes$.value.length === 0 && userType === "all") {
            return true;
        }
        return this.selectedUserTypes$.value.some(
            (itemId) => itemId === userType
        );
    }
    selectUserType(userType: string) {
        this.selectedUserTypes$.pipe(take(1)).subscribe((selected) => {
            const selectedIdx = selected.findIndex(
                (itemId: string) => itemId === userType
            );
            if (selectedIdx !== -1) {
                selected.splice(selectedIdx, 1);
            } else {
                if (userType === "all") {
                    selected = [];
                } else {
                    selected.push(userType);
                }
            }
            this.selectedUserTypes$.next(selected);
        });
    }

    getUserAccountType(account: any): string {
        return getUserType({
            isPremium: account.isPremium,
            type: account.accountType,
        });
    }

    goToAccount(account) {
        this.searchHistoryService.addHistoryItem({
            type: "account",
            name: `${account.contact.firstname} ${account.contact.surname}`,
            data: account,
        });
        this.searchActionsService.goToAccount(account);
    }

    createOrderWithCustomer(account: any) {
        this.searchHistoryService.addHistoryItem({
            type: "account",
            name: `${account.contact.firstname} ${account.contact.surname}`,
            data: account,
        });
        this.searchActionsService.createOrderWithCustomer(account);
    }
    callAccount(account: any) {
        this.searchHistoryService.addHistoryItem({
            type: "account",
            name: `${account.contact.firstname} ${account.contact.surname}`,
            data: account,
        });
        this.searchActionsService.callAccount(account);
    }

    startChat(account: any) {
        this.searchHistoryService.addHistoryItem({
            type: "account",
            name: `${account.contact.firstname} ${account.contact.surname}`,
            data: account,
        });
        this.searchActionsService.startChat(account);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
    }

    /*
     * Get item height depend on accpunt.orderCount
     */
    getItemHeight(account: any): number {
       if (account.orderCount > 0) {
        return this.HIGHER_ITEM_SIZE;
       } else {
        return this.ITEM_SIZE;
       }
    }

    /*
     * Get scroll panel height depend on accpunt.orderCount
     */
    getScrolPanelHeight(accounts: any[]): number {
       
        const height = accounts.reduce((acc, account) => {
            if(account.orderCount > 0) {
                return acc + this.HIGHER_ITEM_SIZE;
            }
            return acc + this.ITEM_SIZE;
        }, 0);
        
        return height;
    }
}
